var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.489,
    height: 24.49,
    viewBox: "0 0 24.489 24.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-svgrepo-com_1_",
    "data-name": "search-svgrepo-com (1)",
    transform: "translate(-3.24 -3.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44966",
    "data-name": "Path 44966",
    d: "M13.772,24.3a10.532,10.532,0,1,1,4.03-.8A10.532,10.532,0,0,1,13.772,24.3Zm0-18.951A8.392,8.392,0,1,0,19.705,7.81,8.392,8.392,0,0,0,13.772,5.352Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44967",
    "data-name": "Path 44967",
    d: "M21.938,22.987a1.036,1.036,0,0,1-.741-.308L15.42,16.9A1.049,1.049,0,0,1,16.9,15.42L22.679,21.2a1.049,1.049,0,0,1,0,1.483,1.036,1.036,0,0,1-.741.308Z",
    transform: "translate(4.743 4.743)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c4af079bfe88ef8863caddc982cd8585.svg";
export { ForwardRef as ReactComponent };